import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MainHeader } from '../MainHeader';
import { PhotoCollection } from '../PhotoCollection';
import { images } from './images';
import './styles.css';

export const Weddings = () => {
  useEffect(() => {
    document.title = "Rue's Events Designs - Weddings";
  }, []);

  return (
    <div className="collection-page">
      <MainHeader home={false} about={false} gallery={true} contact={false} />
      <section className="collection-hero">
        <p className="section-kicker">Rue's Events gallery</p>
        <h1>Weddings</h1>
        <p>A collection of wedding celebrations styled and brought to life by Rue's Events Designs.</p>
        <div className="collection-back-link">
          <Link to="/gallery">← Back to all collections</Link>
        </div>
      </section>
      <div className="collection-gallery-shell">
        <PhotoCollection images={images} label="Weddings" />
      </div>
    </div>
  );
};
